'use client';

import React, { ReactNode, useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import Link from 'next/link';
import { useIntl } from 'react-intl';

type TBreadCrumbProps = {
    separator: ReactNode;
};

export default function BreadCrumbs({ separator }: TBreadCrumbProps) {
    const paths = usePathname();
    const intl = useIntl();
    const pathNames = paths.split('/').filter(path => path);
    const isProfilePage = paths === '/user';

    const [dynamicName, setDynamicName] = useState<string | null>(null);

    const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

    //   set BreadCrumbs name in breadcrumb while edit on view data 
    useEffect(() => {
        const handleNameEvent = (e: CustomEvent) => {
            setDynamicName(e.detail?.name || null);
        };
        window.addEventListener('BreadCrumbs-name-available', handleNameEvent as EventListener);
        return () => {
            window.removeEventListener('BreadCrumbs-name-available', handleNameEvent as EventListener);
        };
    }, []);

    return (
        <div className="flex [.header_&]:below-lg:hidden items-center gap-1.25 text-xs lg:text-sm font-medium mb-2.5 lg:mb-0">
            {!isProfilePage &&
                pathNames.map((link, index) => {
                    const href = `/${pathNames.slice(0, index + 1).join('/')}`;
                    const isLast = index === pathNames.length - 1;
                    const isNumeric = /^\d+$/.test(link);

                    const translationKey = `BREADCRUMB_${link.toUpperCase()}`;
                    const translatedLink = intl.formatMessage(
                        { id: translationKey, defaultMessage: capitalize(link) }
                    );

                    return (
                        <React.Fragment key={index}>
                            <span className="text-gray-700">
                                <Link href={href}>
                                    {isLast && isNumeric && dynamicName ? dynamicName : translatedLink}
                                </Link>
                            </span>
                            {!isLast && separator}
                        </React.Fragment>
                    );
                })}
        </div>
    );
}
